import { render, staticRenderFns } from "./AspectBasic.vue?vue&type=template&id=cf60e004"
import script from "./AspectBasic.vue?vue&type=script&lang=js"
export * from "./AspectBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports